import { render, staticRenderFns } from "./PartnerInfoStocks.vue?vue&type=template&id=4a5a723f&scoped=true"
import script from "./PartnerInfoStocks.vue?vue&type=script&lang=js"
export * from "./PartnerInfoStocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a723f",
  null
  
)

export default component.exports